<template>
  <div class="know-box">
    <div class="know-header-box u-flex-col u-col-center">
      <img src="../assets/images/img_know_1.png" />
      <p>正规持牌金融机构，应你之急</p>
    </div>
    <!-- 页面元素 -->
    <div class="know-content-box">
      <!-- 标题1 -->
      <div class="u-flex u-col-stretch know-title">
        <div class="u-flex-1 u-flex-col u-row-between know-title-font">
          <div class="font-tit">01.如何在闪融花获得贷款？</div>
          <div class="font-ntit">
            仅需3步即可在闪融花轻松获得最高200,000元贷款
          </div>
        </div>
      </div>
      <!-- 内容1 -->
      <div class="know-cont know-cont1-box">
        <!-- 在首页点击提升额度 -->
        <div class="u-flex u-col-top know-cont1">
          <img class="know-cont-img" src="../assets/images/img_know_2.png" />
          <div class="know-cont1-right">
            <div class="know-cont-tit">在首页点击提升额度</div>
            <div class="know-cont1-cont">
              首页点击【提升额度】按钮进入信息采集页面，按照页面中的引导依次如实完成资料填写，这一步大概率会让你使用2分钟的时间进行。完成后你有机会获得2张提额券。
            </div>
          </div>
        </div>
        <!-- 完成资料提交 -->
        <div class="u-flex u-col-top know-cont1">
          <img class="know-cont-img" src="../assets/images/img_know_3.png" />
          <div class="know-cont1-right">
            <div class="know-cont-tit">完成资料提交</div>
            <div class="know-cont1-cont">
              信息采集完成后点击页面中【下一步】按钮提交您的贷款申请，您的贷款申请预计再5分钟内可以完成审核，在此期间建议您开启通知权限，及时获知审核结果。
            </div>
          </div>
        </div>
        <!-- 完成提款 -->
        <div class="u-flex u-col-top know-cont1">
          <img class="know-cont-img" src="../assets/images/img_know_4.png" />
          <div class="know-cont1-right">
            <div class="know-cont-tit">完成提款</div>
            <div class="know-cont1-cont">
              额度审核完成后，在首页点击【提款】按钮，绑定您的银行卡，配合安全方面考虑，需要你完成人脸识别，操作完成后，资金将在10分钟内打款到您的指定账户。
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="know-content-box">
      <!-- 标题2 -->
      <div class="u-flex u-col-stretch know-title">
        <div class="u-flex-1 u-flex-col u-row-between know-title-font">
          <div class="font-tit">02.如何还款到闪融花？</div>
        </div>
      </div>
      <!-- 内容2 -->
      <div class="know-cont know-cont1-box">
        <div class="u-flex u-col-top know-cont1">
          <img class="know-cont-img" src="../assets/images/img_know_2.png" />
          <div class="know-cont1-right">
            <div class="know-cont-tit">手动还款</div>
            <div class="know-cont1-cont">
              您贷款提取完成后，首页会为您生成还款计划，您可以按照还款计划中约定的时间，按照页面指引操作还款，为了避免逾期导致征信不良，建议您开启通知获得还款信息。
            </div>
          </div>
        </div>
      </div>
      <!-- 内容2 -->
      <div class="know-cont know-cont1-box">
        <div class="u-flex u-col-top know-cont1">
          <img class="know-cont-img" src="../assets/images/img_know_3.png" />
          <div class="know-cont1-right">
            <div class="know-cont-tit">自动还款</div>
            <div class="know-cont1-cont">
              在您的贷款申请审核通过后，绑定银行卡进行提款操作时，勾选页面中【同步绑定为还款卡】按钮，同时勾选【三方代扣协议】，我们将为您开通自动还款功能，会根据还款计划自动从绑定的银行卡中扣款，为了避免扣款失败导致的逾期问题，请您在绑定的银行卡中预留足够的资金。
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="know-content-box">
      <!-- 标题3 -->
      <div class="u-flex u-col-stretch know-title">
        <div class="u-flex-1 u-flex-col u-row-between know-title-font">
          <div class="font-tit">03.如何提升闪融花的额度？</div>
        </div>
      </div>
      <!-- 内容3 -->
      <div class="know-cont know-cont1-box">
        <div class="u-flex u-col-top know-cont1">
          <img class="know-cont-img" src="../assets/images/img_know_2.png" />
          <div class="know-cont1-right">
            <div class="know-cont-tit">确保信息真实有效</div>
            <div class="know-cont1-cont">
              借款人在提交自己的个人信息资料时，确保所填信息真实有效。写的信息越完善，所获得得贷款额度可能就越高。
            </div>
          </div>
        </div>
      </div>
      <!-- 内容3 -->
      <div class="know-cont know-cont1-box">
        <div class="u-flex u-col-top know-cont1">
          <img class="know-cont-img" src="../assets/images/img_know_3.png" />
          <div class="know-cont1-right">
            <div class="know-cont-tit">保持良好的还款记录</div>
            <div class="know-cont1-cont">
              良好的还款习惯将提升您的综合信用评分。贷款机构会根据用户的还款记录评定用户的个人信用，保证按时还款，拥有良好的还款记录。
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Know",
};
</script>

<style lang="scss" scoped>
.know-box {
  background-image: url("../assets/images/img_know.png");
  background-size: 100% 4.32rem;
  background-repeat: no-repeat;
  padding: 0.6rem 0.3rem;
  background-color: #f4f4f4;

  .know-header-box {
    > img {
      width: 1.94rem;
      height: 0.47rem;
    }

    > P {
      font-family: Source Han Sans CN;
      font-weight: 400;
      font-size: 0.26rem;
      color: #ffffff;
      line-height: 0.4rem;
      margin-top: 0.23rem;
    }
  }

  .know-content-box {
    padding: 0.4rem 0.3rem;
    background: #fff;
    border-radius: 0.24rem;
    margin-top: 0.39rem;

    .know-title {
      margin-bottom: 0.44rem;

      .know-title-font {
        margin-left: 0.2rem;
      }

      .font-tit {
        font-size: 0.28rem;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 500;
        color: #101010;
        line-height: 0.3rem;
      }

      .font-ntit {
        font-size: 0.24rem;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        color: #999999;
        line-height: 0.3rem;
        margin-top: 0.12rem;
      }
    }

    .know-cont {
      padding: 0rem 0.24rem 0.4rem;
    }

    .know-cont-img {
      width: 0.36rem;
      height: 0.36rem;
    }

    .know-cont-tit {
      font-size: 0.26rem;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: 500;
      color: #fe393c;
      line-height: 0.34rem;
    }

    .know-cont1-cont {
      font-size: 0.24rem;
      font-family: PingFangSC, PingFangSC-Medium;
      color: #666666;
      line-height: 0.34rem;
      margin-top: 0.16rem;
    }

    .know-cont1-box {
      .know-cont1 {
        margin-bottom: 0.48rem;

        &:last-child {
          margin-bottom: 0;
        }
      }

      .know-cont1-right {
        margin-left: 0.16rem;
      }
    }

    .know-cont2-box {
      margin-bottom: 0.24rem;

      & + .know-cont2-box {
        margin-bottom: 0.6rem;
      }
      .know-cont2-img {
        display: block;
        width: 0.48rem;
        height: 0.48rem;
        margin-right: 0.16rem;
      }

      .know-cont2-tit {
        font-size: 0.24rem;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 500;
        color: #111c31;
        line-height: 0.34rem;
      }

      .know-cont2-cont {
        font-size: 0.24rem;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: justify;
        color: #868e9e;
        line-height: 0.36rem;
        margin-top: 0.2rem;
      }
    }

    .know-cont3-box {
      .know-cont3-img {
        display: block;
        width: 1.44rem;
        height: 1.44rem;
        margin-bottom: 0.24rem;
      }

      .know-cont3-tit {
        font-size: 0.24rem;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 500;
        color: #111c31;
        line-height: 0.34rem;
        margin-bottom: 0.14rem;
      }

      .know-cont3-ntit {
        font-size: 0.24rem;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: justify;
        color: #868e9e;
        line-height: 0.36rem;
      }
    }
  }
}
</style>
